import { INotification, EnumNotificationType } from '@simplyfly/shared';
export type NotificationIconKey = 'bell' | 'folder' | 'planeDeparture';

export const getNotificationIconKey = (notification: INotification): NotificationIconKey => {
  switch (notification.type) {
    default:
      return 'bell';
    case EnumNotificationType.enquiryIsConfirmed:
      return 'folder';
    case EnumNotificationType.cfmuNotification:
      return 'planeDeparture';
    case EnumNotificationType.enquiryFollowUp:
      return 'folder';
  }
};

export const getNotificationUrl = (notification: INotification): string | null => {
  switch (notification.type) {
    case EnumNotificationType.enquiryIsConfirmed:
    case EnumNotificationType.enquiryFollowUp:
      return notification.params.enquiryId
        ? '/admin/enquiries/' + notification.params.enquiryId
        : null;
    case EnumNotificationType.cfmuNotification:
      return notification.params.enquiryId
        ? '/admin/enquiries/' + notification.params.enquiryId + '/cfmu'
        : null;
    case EnumNotificationType.purchaseInvoicePaymentReminder:
      return notification.params.invoiceId
        ? '/admin/invoices/' + notification.params.invoiceId
        : null;
  }

  return null;
};
